import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_STYLE_MASTER;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
